import React from 'react';
import { AuthWrapper, AuthSubmit, EmailInput, PasswordInput, AuthFormHeader, ForgotPasswordLink } from '@src/features/auth/components';
import { useSignInForm } from '@src/features/auth/hooks';
import { REQUIRED_VALIDATION_TEXT } from '@src/core/config';
import { ArcStack } from '@src/core/ui';

const SignInPage: React.FC = () => {
  const { register, formState: { errors }, onSubmit, isLoading } = useSignInForm();

  return (
    <AuthWrapper>
      <AuthFormHeader
        title='Welcome'
        subtitle='Enter your email and password to proceed'
      />
      <ArcStack component='form' mt={3} gap={1} onSubmit={onSubmit}>
        <EmailInput
          register={register('email', { required: REQUIRED_VALIDATION_TEXT })}
          error={errors.email}
        />
        <PasswordInput
          register={register('password', { required: REQUIRED_VALIDATION_TEXT })}
          error={errors.password}
        />
        <ForgotPasswordLink />
        <AuthSubmit
          buttonText='SIGN IN'
          isLoading={isLoading}
        />
      </ArcStack>
    </AuthWrapper>
  );
};

export default SignInPage;